import React from 'react';
import {Navbar, Nav} from 'react-bootstrap';
import {Link} from 'react-router-dom';
import "./Menu.scss";
import {faArrowRightFromBracket} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
const Menu = ({userEmail}) => {

    let navToggle = "";

    if(userEmail) {
        navToggle = (
            <>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="ml-auto">
                        <span>{userEmail}</span>
                        <Link to="/signOut"><FontAwesomeIcon className="icon" icon={faArrowRightFromBracket} />Sign out</Link>                    </Nav>
                </Navbar.Collapse>
            </>
        )
    }

    return <Navbar className="navbar-full sticky-top" expand="lg">
        <Link to="/"><img className="nav-logo" src="/image/Logo_Storadera.svg" alt="Storadera logo"/></Link>
        {navToggle}
    </Navbar>
}

export default Menu;